<template>
  <van-popup v-model="show" position="bottom" style="height:145px;" class="share-box">
    <div>
      <div class="title">分享</div>
      <van-row class="share-links">
        <van-col span="6">
          <div class="share-icon-d">
            <van-icon class-prefix="iconfont" name="s icon-weixin" class="share-icon share-weixin"></van-icon>
          </div>
          <span>微信好友</span>
        </van-col>
        <van-col span="6">
          <div class="share-icon-d">
            <van-icon
              class-prefix="iconfont"
              name="s icon-pengyouquan"
              class="share-icon share-pengyou"
            ></van-icon>
          </div>
          <span>朋友圈</span>
        </van-col>
        <van-col span="6">
          <div class="share-icon-d">
            <van-icon class-prefix="iconfont" name="s icon-weibo" class="share-icon share-weibo"></van-icon>
          </div>
          <span>新浪微博</span>
        </van-col>
        <van-col span="6">
          <div class="share-icon-d">
            <van-icon
              class-prefix="iconfont"
              name="s icon-lianjie"
              class="share-icon share-copy"
              @click="copyLink"
            ></van-icon>
          </div>
          <span>复制链接</span>
        </van-col>
      </van-row>
    </div>
    <div class="van-hairline--top cancel-btn" @click="show=false">取消</div>
  </van-popup>
</template>

<script>
export default {
  name: "SharePopup",
  props: {
    value: Boolean
  },
  data() {
    return {
      show: false
    };
  },
  watch: {
    value(val) {
      this.show = val;
      if (!val) {
        this.$emit("input", false);
      }
    },
    show(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    copyLink() {
      var obj = this;
      var url = window.location.href;
      this.$copyText(url).then(
        function() {
          obj.$toast("已复制链接");
          //console.log(e);
          obj.show = false;
        },
        function() {
          obj.$toast("复制失败");
          //console.log(e);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.share-box .title {
  text-align: center;
  line-height: 40px;
  font-size: 14px;
}
.share-box .cancel-btn {
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.share-links {
  text-align: center;
  font-size: 12px;
  //color: #000;
}
.share-icon-d {
  margin-bottom: 5px;
}
.share-icon {
  display: inline-block;
  font-size: 24px;
  color: #fff;
  height: 36px;
  width: 36px;
  line-height: 36px;
  border-radius: 50%;
}
.share-weixin {
  background-color: #07c160;
}

.share-weibo {
  background-color: #ee5e5e;
}
.share-pengyou {
  background-color: #514d4c;
}
.share-copy {
  background-color: #5280ce;
}
</style>